// extracted by mini-css-extract-plugin
module.exports = {"fileButton":"backgroundInput_fileButton__3HcS4","fileArea":"backgroundInput_fileArea__1KglN"};